import React from "react";
import { Layout } from "views/common/Layout";
import { Check } from "lucide-react";

export const SignIn = () => {
    return (
        <Layout>
            <div className="min-h-[88vh] flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800">
                <div className="w-full max-w-md px-4 py-8">
                    <div className="bg-white dark:bg-gray-800 rounded-xl p-6">
                        <div className="text-center mb-8">
                            <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-50 dark:bg-gray-700 mb-4">
                                <Check className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                            </div>
                            <h1 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                                Welcome to LaunchHero.fyi
                            </h1>
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                Sign in to manage your launches and saved
                                products.
                            </p>
                        </div>
                        <div className="space-y-4 ml-4">
                            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                                <Check className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                                <span>Track your launches</span>
                            </div>
                            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                                <Check className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                                <span>Save your favorite products</span>
                            </div>
                        </div>

                        <div className="mt-8 px-2">
                            <a
                                href="/api/auth/google"
                                className="w-full py-2 px-4 hover:bg-blue-100 text-sm font-medium rounded-lg transition-colors border flex items-center justify-center space-x-2"
                            >
                                <img
                                    src="/images/google-logo.png"
                                    alt="Google"
                                    className="w-3.5 h-3.5"
                                />
                                <span>Continue with Google</span>
                            </a>
                        </div>

                        <div className="mt-8 text-center text-xs text-gray-600 dark:text-gray-400 px-2">
                            <p>
                                By signing in, you agree to our{" "}
                                <a
                                    href="/terms"
                                    className="text-blue-600 hover:text-blue-500 dark:text-blue-400"
                                >
                                    Terms of Service
                                </a>{" "}
                                and{" "}
                                <a
                                    href="/privacy"
                                    className="text-blue-600 hover:text-blue-500 dark:text-blue-400"
                                >
                                    Privacy Policy
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
